import React from "react";
import { strings } from "../localization";
import { Container, Row, Col } from "react-bootstrap";
import '../views/LoginPage.css'

function InitialLoading({ isOrganisationLoading, isConfigLoading }) {
  return (
    <Container fluid className="login-page-container">
      <Row className="login-content justify-content-center align-items-center">
        <Col md={6} className="text-center">
          <div className="loading-container">
            <>
              <div
                className="spinner-border text-primary"
                role="status"
                style={{ width: "3rem", height: "3rem" }}
              >
                <span className="sr-only">{strings.loading}...</span>
              </div>
              <p className="mt-3 text-muted">{`${strings.loading}...`}</p>
              <div
                className="progress mt-3"
                style={{ width: "200px", height: "4px" }}
              >
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{
                    width: isOrganisationLoading
                      ? "50%"
                      : isConfigLoading
                      ? "100%"
                      : "0%",
                    transition: "width 0.3s ease",
                  }}
                  aria-valuenow={
                    isOrganisationLoading ? 50 : isConfigLoading ? 100 : 0
                  }
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
              {`${strings.loading}...`}
            </>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default InitialLoading;
